import React from 'react'

const UserLoggedInIcon = () => (
  <>
    <img src="/catalogo/images/loggedInIcon.svg" alt="user-loggedin-icon" />
  </>
)

export default UserLoggedInIcon
